export function isNotNullOrUndefined(value)
{
    return value !== null && value !== undefined
}